var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_Uint8Array.js
// module id = wTs6
// module chunks = 1